import { isMockMode, post, simulateDelay } from "../api";

export const updateSubbedSubsManagers = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Subscriptions/UpdateSubscribedSub`, data, {
		successMessage: "Subscription successfully updated",
	});
};
